import type {ScheduleDateObjType} from '../../entities/recruitment/schema';

export const convertDateToScheduleDateObj = (
  dateStr: string,
  isAllDay: boolean,
): ScheduleDateObjType | undefined => {
  if (dateStr === '0001-01-01T00:00:00Z') {
    return undefined;
  }

  const convertedDate: ScheduleDateObjType = {
    dayOfWeek: '',
    year: 0,
    month: 0,
    day: 0,
    time: '',
  };
  const dateObj = new Date(
    new Date(dateStr).toLocaleString('ja-JP', {
      timeZone: 'Asia/Tokyo',
    }),
  );
  convertedDate.dayOfWeek = '日月火水木金土'.charAt(dateObj.getDay());
  convertedDate.year = dateObj.getFullYear();
  convertedDate.month = dateObj.getMonth() + 1;
  convertedDate.day = dateObj.getDate();
  convertedDate.time = isAllDay
    ? ''
    : `${dateObj.getHours()}:${`0${dateObj.getMinutes()}`.slice(-2)}`;
  return convertedDate;
};
